const mEditionAcademyUsersProfileMaps = {
  mEditionAcademyUsersProfileMaps: {
    actions: {
      add: 'Incluir'
    },

    alerts: {
      createInscripcion: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo.',
        success: 'La inscripción fue procesada exitosamente. El alumno recibirá un email de notificación para hacerle saber que su inscripción ha sido dada de alta.'
      }
    }
  }
}
export default mEditionAcademyUsersProfileMaps
